module.exports = __webpack_public_path__ + "static/media/text.e672f74e.svg";